import { IDimensions } from '../../Fakturabild/Components/XmlFaktura';

export const getBaseZoom = (
  contentDimensions: IDimensions,
  imageDimensions: IDimensions
): number => {
  const heightBasedZoom = contentDimensions.height / imageDimensions.height;
  const widthBasedZoom = contentDimensions.width / imageDimensions.width;

  return Math.min(heightBasedZoom, widthBasedZoom);
};

export const getTranslateCenter = (
  contentLength: number,
  imageLength: number,
  scale: number
): number => (contentLength / 2 - imageLength / 2) / scale;
